import React from "react";
import "./Skeleton.scss";

type SkeletonType = "text" | "title" | "avatar" | "card" | "form";

type BaseProps = {
    type?: Exclude<SkeletonType, "form">;
    count?: number;
};

type FormProps = {
    type: "form";
    rows?: number;
    optionsPerRow?: number;
};

type SkeletonProps = BaseProps | FormProps;

const CONFIG = {
    text: { count: 3 },
    title: { count: 1 },
    avatar: { count: 1 },
    card: { count: 1 },
    form: { rows: 3, optionsPerRow: 4 },
} as const;

const Skeleton: React.FC<SkeletonProps> = (props) => {
    const type = props.type ?? "text";

    // ===== FORM =====
    if (type === "form") {
        const { rows, optionsPerRow } = {
            ...CONFIG.form,
            ...props,
        };

        return (
            <div className="skeleton skeleton--form">
                {Array.from({ length: rows }).map((_, rowIndex) => (
                    <div key={rowIndex} className="skeleton__row">
                        <div className="skeleton__title" />
                        <div className="skeleton__options">
                            {Array.from({ length: optionsPerRow }).map((_, i) => (
                                <div key={i} className="skeleton__option">
                                    <div className="skeleton__checkbox" />
                                    <div className="skeleton__label" />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    // ===== DEFAULT TYPES =====
    const { count } = {
        ...CONFIG[type],
        ...(props as BaseProps),
    };

    return (
        <div className={`skeleton skeleton--${type}`}>
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="skeleton__item" />
            ))}
        </div>
    );
};

export default Skeleton;